module.exports = __webpack_public_path__ + "static/media/fashion.3b34f3ee.jpg";